var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { StoryStateModel } from './story.state.model';
import { FetchStory, LoadStorySuccess, SynchronizeChapters, ResetStory, LoadStoryChunk, SetIncomingStory, LoadStory, BuildStory, UnloadStory, SetStoryText, SetStory, SetStoryId, LoadStoryChunkSuccess, LoadStoryFail, ImportStory, ReorderLoadChunks, ImportStorySuccess } from './story.actions';
import { StoryService } from '../story.service';
import { SetChapter, SetChapters, SelectChapter, RegisterChapterThumbnails } from './chapters/story.chapters.actions';
import { StoryChaptersState } from './chapters/story.chapters.state';
import { SetLabels } from './labels/story.labels.actions';
import { StoryLoadTypeEnum } from '../models/story-load-type.enum';
import { mergeModules } from '../merge/merge-modules';
import { Thumbnail } from 'src/app/shared/thumbnail-utils';
import { environment } from 'src/environments/environment';
import { SerializeModuleService } from 'src/app/edit/serialize-module.service';
import { TrimConfiguration } from 'src/app/edit/models/trim-config.model';
import { partition } from 'lodash';
var ɵ0 = undefined;
var initialState = {
    loading: false,
    incoming: {
        id: ɵ0,
        type: undefined
    },
    storyId: undefined,
    storyType: undefined,
    loadingChunk: null,
    loadType: StoryLoadTypeEnum.OnDemand,
    loadChunks: [],
    loadChunksRemaining: [],
    thumbnailLookup: []
};
var StoryState = /** @class */ (function () {
    function StoryState(store, storyService, serializeModuleService) {
        this.store = store;
        this.storyService = storyService;
        this.serializeModuleService = serializeModuleService;
    }
    StoryState_1 = StoryState;
    /**
     * Selectors
     */
    StoryState.getStory = function (state) {
        return state.story;
    };
    StoryState.getStoryId = function (state) {
        return state.storyId;
    };
    StoryState.getLoadChunks = function (state) {
        return state.loadChunks;
    };
    StoryState.getLoadChunksRemaining = function (state) {
        return state.loadChunksRemaining;
    };
    StoryState.getStoryInfo = function (state) {
        return {
            id: state.storyId,
            type: state.storyType
        };
    };
    StoryState.getLoadType = function (state) {
        return state.loadType;
    };
    StoryState.getIncomingStoryInfo = function (state) {
        return state.incoming;
    };
    /**
     *
     * Actions
     */
    StoryState.prototype.setStoryText = function (context, action) {
        var story = context.getState().story;
        if (story) {
            context.patchState({
                story: __assign({}, story, { displayName: action.displayName })
            });
        }
    };
    StoryState.prototype.setStory = function (context, action) {
        context.patchState({
            story: action.story
        });
    };
    StoryState.prototype.SetStoryId = function (context, action) {
        context.patchState({
            storyId: action.id
        });
    };
    StoryState.prototype.setIncomingStory = function (context, action) {
        var state = context.getState();
        var id = action.id, type = action.type, reset = action.reset;
        if (id !== state.storyId || reset) {
            context.patchState({
                incoming: { id: id, type: type }
            });
        }
        else if (reset) {
            context.dispatch(new BuildStory(action.id, state.story, action.type, state.loadType));
        }
    };
    // load the entire incoming story and its assets
    StoryState.prototype.loadStory = function (context, action) {
        this.storyService.getStory(action.id, action.type, action.lang)
            .subscribe(
        // success
        function (story) {
            context.dispatch(new LoadStorySuccess(story, action.id, action.type));
        }, 
        // error
        function () {
            context.dispatch(new LoadStoryFail(action.id, action.type));
        });
    };
    // fetch the story JSON from BD servers and patch state with app formatted story
    // #NOTE: [EM] - fetch->build->load baked into this function. Assumes you'll only have a single story loaded
    StoryState.prototype.fetchStory = function (context, action) {
        this.storyService.getStory(action.id, action.type, action.lang)
            .subscribe(
        // success
        function (story) {
            context.dispatch(new LoadStorySuccess(story, action.id, action.type));
        }, 
        // error
        function () {
            context.dispatch(new LoadStoryFail(action.id, action.type));
        });
    };
    // Put story into engine and kickoff asset loading. 
    // #TODO: [EM] This should be renamed because it's primary job is to unload before continuing load
    StoryState.prototype.loadStorySuccess = function (context, action) {
        // #TODO: [MR] - Discuss with Evan. unloadStory(null) was the previous value, and we depended on Human.
        // Get last story ID from state. This will be overwritten later on Human.modules.modules for the right id.
        var _a = context.getState(), storyId = _a.storyId, loadType = _a.loadType;
        this.storyService.unloadStory(null).subscribe(function () {
            context.dispatch(new BuildStory(action.id, action.story, action.type, loadType));
        });
    };
    StoryState.prototype.buildStoryWorkflow = function (context, storyId, story, storyType, loadType, targetChapterIdx, thumbnails) {
        var _this = this;
        if (targetChapterIdx === void 0) { targetChapterIdx = 0; }
        if (thumbnails === void 0) { thumbnails = new Map(); }
        this.storyService.buildStory(storyId, story, true).subscribe(function (built) {
            // parse chapters from Human Engine
            var chapters = _this.storyService.getStoryChapters(storyId, storyType);
            // parse labels
            var labels = [];
            chapters.forEach(function (chapter) {
                labels = __spread(labels, chapter.labels);
            });
            var config = _this.storyService.getLoadConfig(storyId, targetChapterIdx);
            var loadChunks = _this.storyService.getStoryLoadChunks(storyId, config, loadType);
            // patch story state
            context.patchState({
                storyId: storyId,
                story: story,
                loadChunks: loadChunks,
                loadChunksRemaining: loadChunks,
                incoming: { id: undefined, type: undefined }
            });
            // patch story-chapters state with chapters
            context.dispatch(new SetChapters(chapters));
            context.dispatch(new RegisterChapterThumbnails(thumbnails));
            context.dispatch(new SetLabels(labels));
            context.dispatch(new SelectChapter(chapters[targetChapterIdx]));
            // kick off loading
            context.dispatch(new LoadStoryChunk());
        });
    };
    // I need an entry point to this. Ask Mike
    StoryState.prototype.importStorySuccess = function (context, action) {
        var _this = this;
        var state = context.getState();
        var storyType = state.storyType;
        var storyId = state.storyId;
        var loadType = StoryLoadTypeEnum.Progressive;
        var serializeInPlace = true;
        var namespaceMap = {};
        var trimConfig = new TrimConfiguration();
        var replaceObjectId = false;
        var story = this.store.selectSnapshot(StoryState_1.getStory);
        var chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        var currentStory = this.serializeModuleService.serialize(serializeInPlace, namespaceMap, trimConfig, replaceObjectId, story, chapters).story;
        var newStory = mergeModules(currentStory, storyId, action.story, action.id, environment.exportType);
        // when a new module is imported, its thumbnails reference the origin module and chapters
        // we need a look up table to know where to get thumbnails before we save the module to a bookmark.
        // here we build the lookup table, and read it in Thumbnail.generateThumbnailUrls
        var originalThumbnails = currentStory.chapters.map(function (chapter, i) {
            var newChapterId = chapter.id;
            var originalChapterId = chapter.id;
            var originalStoryId = storyId;
            return { newChapterId: newChapterId, originalChapterId: originalChapterId, originalStoryId: originalStoryId };
        });
        var thumbnailLookup = (state.thumbnailLookup || [])
            .concat(action.story.chapters.map(function (chapter, i) {
            var startIndex = currentStory.chapters.length;
            var newChapterId = newStory.chapters[startIndex + i].id;
            var originalChapterId = chapter.id;
            var originalStoryId = action.id;
            return { newChapterId: newChapterId, originalChapterId: originalChapterId, originalStoryId: originalStoryId };
        }));
        context.patchState({
            thumbnailLookup: thumbnailLookup
        });
        var thumbnails = Thumbnail.generateThumbnailUrls(__spread(originalThumbnails, thumbnailLookup));
        // merge any thumbnails that currently live in state that are a blob
        var prevThumbnails = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
        var blobThumbnails = new Map(__spread(prevThumbnails).filter(function (entry) { return entry[1].snapshot; }));
        var newThumbnails = new Map(__spread(thumbnails, blobThumbnails));
        // a story must be unloaded before it is rebuilt
        // we need to flush the engine's definition of the scene graph, because we made a new one in combineModules
        var purgeAssets = true; // we need to purge assets until parsing animations has been decoupled from fetching from the server
        this.storyService.unloadStory(null, purgeAssets).subscribe(function () {
            _this.buildStoryWorkflow(context, storyId, newStory, storyType, loadType, newStory.chapters.length - 1, newThumbnails);
        });
    };
    // Build story from story data. 
    StoryState.prototype.buildStory = function (context, action) {
        // build and activate story into Human Engine
        var thumbnailLookup = action.story.chapters.map(function (chapter, i) {
            var newChapterId = chapter.id;
            var originalChapterId = chapter.id;
            var originalStoryId = action.id;
            return { newChapterId: newChapterId, originalChapterId: originalChapterId, originalStoryId: originalStoryId };
        });
        var thumbnails = Thumbnail.generateThumbnailUrls(thumbnailLookup);
        var targetChapterIdx = action.chapterIdx || 0;
        this.buildStoryWorkflow(context, action.id, action.story, action.type, action.loadType, targetChapterIdx, thumbnails);
    };
    // #TODO: [EM] more granular control of life cycle needed.
    StoryState.prototype.unloadStory = function () { };
    StoryState.prototype.loadStoryChunk = function (context) {
        // assume the chunk to load is in the zeroth index of loadChunksRemaining
        var chunkToLoad = context.getState().loadChunksRemaining[0];
        if (!chunkToLoad) {
            return;
        }
        // update the queue of remaining chunks.
        context.patchState({
            loadingChunk: chunkToLoad
        });
        // load assets through story Service
        // then, dispatch success and continue loading chunks
        this.storyService.loadStoryChunk(chunkToLoad, function () {
            context.dispatch([
                new LoadStoryChunkSuccess(chunkToLoad),
                new LoadStoryChunk()
            ]);
        });
    };
    /**
     * Reorder load chunks, so that the currently selected chapter's chunks are next in the queue.
     * This does not interrupt any currently loading chunks.
     */
    StoryState.prototype.reorderLoadChunks = function (context, action) {
        var loadChunksRemaining = context.getState().loadChunksRemaining;
        var _a = __read(partition(loadChunksRemaining, function (chunk) { return chunk.chapterId === action.chapterId; }), 2), chunksForActiveChapter = _a[0], otherChunks = _a[1];
        context.patchState({
            loadChunksRemaining: __spread(chunksForActiveChapter, otherChunks)
        });
    };
    StoryState.prototype.loadStoryChunkSuccess = function (context, action) {
        var chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        var chapter = __assign({}, chapters.find(function (_chapter) { return action.chunk.chapterId === _chapter.id; }));
        var loadChunksRemaining = context
            .getState()
            .loadChunksRemaining.filter(function (chunk) { return chunk.chunkId !== action.chunk.chunkId; });
        context.patchState({
            loadingChunk: null,
            loadChunksRemaining: loadChunksRemaining
        });
        // merge per-chapter ready state with chunk readyState
        chapter.readyState = __assign({}, chapter.readyState, action.chunk.readyState);
        context.dispatch(new SetChapter(chapter));
    };
    StoryState.prototype.synchronizeChapters = function (context) {
        var chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        var story = context.getState().story;
        context.patchState({
            story: __assign({}, story, { chapters: __spread(chapters) })
        });
    };
    StoryState.prototype.importStory = function (context, action) {
        this.storyService.getStory(action.id, action.type, action.lang)
            .subscribe(
        // success
        function (story) {
            context.dispatch(new ImportStorySuccess(story, action.id, action.type));
        });
    };
    StoryState.prototype.resetStory = function (context) {
        context.setState(initialState);
    };
    var StoryState_1;
    __decorate([
        Action(SetStoryText),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetStoryText]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "setStoryText", null);
    __decorate([
        Action(SetStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetStory]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "setStory", null);
    __decorate([
        Action(SetStoryId),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetStoryId]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "SetStoryId", null);
    __decorate([
        Action(SetIncomingStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetIncomingStory]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "setIncomingStory", null);
    __decorate([
        Action(LoadStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadStory]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "loadStory", null);
    __decorate([
        Action(FetchStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, FetchStory]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "fetchStory", null);
    __decorate([
        Action(LoadStorySuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadStorySuccess]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "loadStorySuccess", null);
    __decorate([
        Action(ImportStorySuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ImportStorySuccess]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "importStorySuccess", null);
    __decorate([
        Action(BuildStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, BuildStory]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "buildStory", null);
    __decorate([
        Action(UnloadStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "unloadStory", null);
    __decorate([
        Action(LoadStoryChunk),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "loadStoryChunk", null);
    __decorate([
        Action(ReorderLoadChunks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ReorderLoadChunks]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "reorderLoadChunks", null);
    __decorate([
        Action(LoadStoryChunkSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadStoryChunkSuccess]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "loadStoryChunkSuccess", null);
    __decorate([
        Action(SynchronizeChapters),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "synchronizeChapters", null);
    __decorate([
        Action(ImportStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ImportStory]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "importStory", null);
    __decorate([
        Action(ResetStory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], StoryState.prototype, "resetStory", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryState, "getStory", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryState, "getStoryId", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryState, "getLoadChunks", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryState, "getLoadChunksRemaining", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryState, "getStoryInfo", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryState, "getLoadType", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryState, "getIncomingStoryInfo", null);
    StoryState = StoryState_1 = __decorate([
        State({
            name: 'story',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [Store,
            StoryService,
            SerializeModuleService])
    ], StoryState);
    return StoryState;
}());
export { StoryState };
export { ɵ0 };
